<ng-form #form="ngForm">
    <div class="flex flex-top-x flex-top-l flex-column-s flex-column-m left">
        <form-field class="block flex-grow">
            <input class="input _email"
                   [class]="canSubmit ? 'b-r-0-x b-r-0-l' : ''"
                   type="email"
                   name="email"
                   validatePattern="email"
                   [required]="true"
                   [placeholder]="'Enter your email address'"
                   [(ngModel)]="data.email"
                   (ngModelChange)="detectChanges()"
                   (keyup.enter)="submit()"
                   cy-subscribeMailInput>
        </form-field>
        @if (canSubmit || app.client.sizeId < 2)
          {
          <button
          [buttonStyle]="'button-1'"
          class="m-t-2-s m-t-2-m"
          [status]="status"
          sl-button="subscribe"
          cy-subscribeButton
          (click)="submit()">
            <span class="no-wrap">{{'Sign up' | translate}}</span>
            </button>
            }
    </div>
    <result class="m-t-1 left block"
            cy-subscribeStatusMessage
            [status]="status"
            [success]="successMessage"></result>
</ng-form>